import React, { useState, useEffect } from 'react';
import { taxAPI } from '../services/api';

const HealthCheck: React.FC = () => {
  const [apiStatus, setApiStatus] = useState<'checking' | 'connected' | 'error'>('checking');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    const checkAPI = async () => {
      try {
        // Try to get tax rates as a simple health check
        await taxAPI.getTaxRates();
        setApiStatus('connected');
      } catch (error: any) {
        setApiStatus('error');
        setErrorMessage(error.message || 'Unknown error occurred');
      }
    };

    checkAPI();
  }, []);

  return (
    <div className="min-h-screen bg-vista-silver-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-lg p-8 border border-vista-silver-200 text-center max-w-md">
        <h1 className="text-3xl font-bold text-vista-silver-900 mb-6">
          API Health Check
        </h1>
        
        <div className="space-y-4">
          {apiStatus === 'checking' && (
            <div className="bg-vista-silver-50 border border-vista-silver-200 rounded-xl p-4">
              <p className="text-vista-silver-700 font-medium">🔄 Checking API connection...</p>
            </div>
          )}
          
          {apiStatus === 'connected' && (
            <div className="bg-green-50 border border-green-200 rounded-xl p-4">
              <p className="text-green-900 font-medium">✅ API connection successful!</p>
              <p className="text-green-700 text-sm mt-2">
                Backend is responding correctly
              </p>
            </div>
          )}
          
          {apiStatus === 'error' && (
            <div className="bg-red-50 border border-red-200 rounded-xl p-4">
              <p className="text-red-900 font-medium">❌ API connection failed</p>
              <p className="text-red-700 text-sm mt-2">
                {errorMessage}
              </p>
              <p className="text-red-600 text-xs mt-2">
                Check if the backend service is running
              </p>
            </div>
          )}
          
          <div className="bg-vista-teal-50 border border-vista-teal-200 rounded-xl p-4">
            <p className="text-vista-teal-900 font-medium">API Base URL</p>
            <p className="text-vista-teal-700 text-sm mt-1 font-mono">
              {process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}
            </p>
          </div>
        </div>
        
        <button
          onClick={() => window.location.href = '/'}
          className="mt-6 bg-gradient-to-r from-vista-teal-500 to-vista-teal-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-vista-teal-600 hover:to-vista-teal-700 transform hover:scale-105 transition-all duration-200"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default HealthCheck;
